export class PasswordReset{
  ebeMail = '';
  recaptchaResponse = '';
}
